module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "BigBox",
    attrs: {
      "id": "synthitcDataH5"
    }
  }, [_c('div', {
    staticClass: "box-top"
  }, [_c('div', {
    staticClass: "box-img",
    on: {
      "click": _vm.Optionsidebar
    }
  }, [_c('img', {
    staticClass: "iconImg",
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/xmapp/xmapp-report-menu.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "box"
    }
  }, [_c('div', {
    attrs: {
      "id": "left-box"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "签约数据",
      "collapse": _vm.isCollapse,
      "unique-opened": true
    },
    on: {
      "select": _vm.selsectOpen
    }
  }, _vm._l((_vm.TreeList), function(item, index) {
    return _c('el-submenu', {
      key: index,
      staticClass: "elsubmenu",
      attrs: {
        "index": item.menuName + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.menuName))])]), _vm._v(" "), _vm._l((item.children), function(itemTow, index) {
      return _c('el-menu-item-group', {
        key: index
      }, [_c('el-menu-item', {
        attrs: {
          "index": itemTow.menuName + ''
        }
      }, [_vm._v(_vm._s(itemTow.menuName))])], 1)
    })], 2)
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right-box"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showOption.apply(null, arguments)
      }
    }
  }, [(_vm.selsectData == '立项数据') ? _c('OperationaDataReportOne', {
    ref: "OperationaDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '招标数据') ? _c('BidsData', {
    ref: "BidsData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '签约数据') ? _c('SignedData', {
    ref: "SignedData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '丢单数据') ? _c('OperationaDataReportThree', {
    ref: "OperationaDataReportThree"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '汇总数据') ? _c('CollectData', {
    ref: "CollectData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '总监数据') ? _c('EliteDirectorDataReportOne', {
    ref: "EliteDirectorDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '持证数据') ? _c('HoldCertificateData', {
    ref: "HoldCertificateData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '甲方数据') ? _c('CustomerOwnerDataReportOne', {
    ref: "CustomerOwnerDataReportOne"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '入库备案数据') ? _c('CustomerOwnerDataReportTwo', {
    ref: "CustomerOwnerDataReportTwo"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '流水数据') ? _c('waterData', {
    ref: "waterData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '应收数据') ? _c('receivableData', {
    ref: "receivableData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '应付数据') ? _c('dealWithData', {
    ref: "dealWithData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '结算数据') ? _c('closeAccountsData', {
    ref: "closeAccountsData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '派单数据') ? _c('sendOrdersData', {
    ref: "sendOrdersData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '巡检数据') ? _c('pollingData', {
    ref: "pollingData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '异常数据') ? _c('abnormalData', {
    ref: "abnormalData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '设计数据') ? _c('designData', {
    ref: "designData"
  }) : _vm._e(), _vm._v(" "), (_vm.selsectData == '购销数据') ? _c('sellingData', {
    ref: "sellingData"
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d0bb15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operationDataH5/syntheticDataH5.vue
// module id = 1657
// module chunks = 471